<template>
  <div class="contact-card">
    <div v-if="!loading">
      <div class="d-flex line-1-25 top-section">
        <div class="left-section" v-if="showCheckBox && canShowCheckBox">
          <CheckBox
            :id="profileData.mcId"
            :name="profileData.linkedinId"
            :value="profileData.mcId"
            :onValueChange="onValueChange"
            :isChecked="isChecked"
            :data="profileData"
          />
          <label :for="profileData.mcId"></label>
        </div>
        <div class="right-section">
          <div class="name float-l width-100" v-if="profileData.fullName">
            {{ profileData.fullName }}
          </div>
          <div
            class="title float-l width-100"
            v-if="profileData.title"
            :title="profileData.title"
          >
            {{ profileData.title }}
          </div>
        </div>
      </div>
      <!-- <div class="error" v-if="errorMsg && errorMsg.msg && !profileData.email">
        <span>{{ errorMsg.msg }}</span>
      </div> -->
      <div
        v-if="
          !profileData.companyName && !profileData.email && !profileData.domain
        "
        class="flex-c no-company"
      >
        <Add-Domain-Find-Email-But
          class="flex-c width-100"
          :text="'Add Company to find Email'"
          :type="'company'"
          :data="profileData"
          v-on:newDomainSubmitted="findEmailWithCustomDomain"
        />
      </div>
      <div
        v-if="
          profileData.companyName && !profileData.domain && !profileData.email
        "
        class="flex-c no-company"
      >
        <Add-Domain-Find-Email-But
          class="flex-c width-100"
          :text="'Add Domain to find Email'"
          :type="'domain'"
          :data="profileData"
          v-on:newDomainSubmitted="findEmailWithCustomDomain"
        />
      </div>
      <div class="flex-c email-hldr" v-if="profileData.email">
        <Email-Icon
          width="18px"
          height="18px"
          viewBox="0 0 24 24"
          class="email-icon"
        />
        <div class="flex-c width-100 p-rel">
          <span
            @mouseover="showCopyMsg = true"
            @mouseout="showCopyMsg = false"
            :class="[{ cursor: !canShowButton() }, 'email noselect ellipsis']"
            @click="
              isContactOwned
                ? copyClipboard(profileData.mcId, profileData.email, 'email')
                : $event.preventDefault()
              showCopyMsg = false
            "
            >{{ profileData.email }}</span
          >
          <div class="flex-c but-holder" v-if="canShowButton()">
            <!-- show get email button only if domain is present -->
            <Find-Email-Button
              :masterContactId="profileData.mcId"
              :fromBulk="fromBulk"
              v-on:response="updatePhoneAndEmailFromSmtp"
              :showUpgradePopup="showUpgradePopup"
              :enableReviewPopup="enableReviewPopup"
              :showActivationPopup="showActivationError"
              :showLinkedInConnect="showLinkedInConnectPrompt"
            />
          </div>
          <div v-if="showCopyMsg && !canShowButton()" class="tooltip">
            Click to copy
          </div>
          <span v-if="profileData.emailDeliverability && !canShowButton()">
            <Email-confidence-card
              class="fn-13"
              :score="profileData.emailDeliverability"
            />
          </span>
          <div class="copy-section flex-c" v-if="!canShowButton()">
            <div class="copy-wrap">
              <input
                type="text"
                :value="profileData.email"
                :id="profileData.mcId + 'email'"
                class="noVisibility"
              />
              <Copy-Icon
                class="copy-icon"
                @click="
                  copyClipboard(profileData.mcId, profileData.email, 'email')
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex-c no-domain"
        v-if="
          !canShowButton() &&
          errorMsg &&
          profileData.domain &&
          !profileData.email
        "
      >
        <Add-Domain-Find-Email-But
          class="flex-c width-100"
          :text="'Try for a different domain'"
          :type="'domain'"
          :data="profileData"
          v-on:newDomainSubmitted="findEmailWithCustomDomain"
        />
      </div>
      <Phone-Section
        :contactId="profileData.mcId"
        :email="profileData.email"
        :errorMsg="errorMsg"
        :profileData="profileData"
        :updatePhone="updatePhoneForId"
        :showUpgradePopup="showUpgradePopup"
        pageName="bulkProfile"
      />
      <Upgrade-Popup
        v-if="showPopup"
        :upgradePopupType="upgradePopupType"
        v-on:clickedOutside="showPopup = false"
      />
      <Activation-Popup
        v-if="showActivationPopup"
        v-on:closed="showActivationPopup = false"
      />

      <Linkedin-Connect-Popup
        v-if="showLinkedInConnect"
        v-on:success="
          showLinkedInConnect = false
          findEmail(true)
        "
        v-on:failed="
          showLinkedInConnect = false
          showUpgradePopup('li_connect_multi')
        "
        v-on:close="showLinkedInConnect = false"
        v-on:skip="
          showLinkedInConnect = false
          showUpgradePopup('li_connect_skip')
        "
      />

      <!-- <div v-if="profileData.phone" class="p-t-7p flex-c phonecard-grid">
        <div
          class="txt-blue flex-c"
          v-for="(ele, index) in profileData.phone"
          :key="index"
        >
          <Phone-Card
            v-if="ele.score == 'high'"
            :profileData="profileData"
            :phone="ele"
            :contactsOwned="isContactOwned"
          />
        </div>
      </div> -->
    </div>
    <div v-else>
      <div class="d-flex line-1-25 top-section">
        <div class="width-70 left-section placeholder">
          <div
            class="name float-l width-100 txt-blue linear-background m-b-5px"
          ></div>
          <div class="title float-l width-100 linear-background"></div>
        </div>
      </div>
      <div class="flex-c email-hldr">
        <Email-Icon
          viewBox="0 0 24 24"
          width="18px"
          height="18px"
          class="email-icon"
        />
        <div class="flex-c width-100">
          <span class="email linear-background"></span>
        </div>
      </div>
      <div class="flex-c email-hldr">
        <Phone-Icon
          viewBox="0 0 24 24"
          width="18px"
          height="18px"
          class="email-icon"
        />
        <div class="flex-c width-100">
          <span class="email linear-background"></span>
        </div>
      </div>
      <!-- <div class="p-t-10p flex-c">
        <div class="txt-blue flex-c">
          <Phone-Card :loading="loading" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import emailConfidenceCard from './EmailConfidenceCard'

import UpgradePopup from '@/components/UpgradePopup.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'
import Checkbox from '@/components/Checkbox.vue'
import emailIcon from '@/assets/icons/svg/email.svg'
import copyIcon from '@/assets/icons/svg/copy.svg'
import phoneIcon from '@/assets/icons/svg/phone.svg'
import { post } from '@/assets/util/rest.js'
import sharedFunctions from '@/assets/util/functions.js'

import findEmailButton from '@/components/FindEmailButton'
import addDomainFindEmail from '@/components/AddDomainFindEmail'
import LinkedinConnectVue from '@/components/LinkedinConnect.vue'
import PhoneSection from '@/components/phoneSection.vue'

export default {
  name: 'ContactCard',
  props: [
    'profileData',
    'loading',
    'showUpgradePopup',
    'enableReviewPopup',
    'requestId',
    'showCheckBox',
    'isContactCheckBtn',
    'canShowCheckBox',
    'isChecked',
    'onValueChange',
    'fromBulk',
    'findEmailCallback',
    'updateEmail',
    'updatePhone',
  ],
  watch: {
    profileData: {
      handler(newValue, oldValue) {
        if (newValue && oldValue != newValue && newValue.email == null) {
          this.findEmail(false, false)
        }
      },
    },
  },
  computed: {
    isContactOwned: function () {
      return this.profileData.contactAlreadyOwned
    },
  },
  updated() {
    if (this.profileData) {
      const id = this.profileData.linkedinId
      if (this.profileData.selectedOtherMatch) {
        if (
          this.profileData.domain == null ||
          (this.smptCompleted && this.profileData.email == null)
        ) {
          this.$store.state.linkedin.bulk.contacts[id] = {
            ...this.profileData.selectedOtherMatch,
            phone: this.profileData.selectedOtherMatch.phoneNumberFromVendor,
          }
        }
      }
    }
  },
  data: function () {
    return {
      errorMsg: null,
      smptCompleted: false,
      showPopup: false,
      showCopyMsg: false,
      showActivationPopup: false,
      showLinkedInConnect: false,
      findEmailLoading: -1,
    }
  },
  components: {
    'Email-confidence-card': emailConfidenceCard,
    'Email-Icon': emailIcon,
    'Find-Email-Button': findEmailButton,
    'Add-Domain-Find-Email-But': addDomainFindEmail,
    'Copy-Icon': copyIcon,
    'Upgrade-Popup': UpgradePopup,
    'Activation-Popup': ActivationPopup,
    'Linkedin-Connect-Popup': LinkedinConnectVue,
    'Phone-Section': PhoneSection,
    'Phone-Icon': phoneIcon,
    CheckBox: Checkbox,
  },
  methods: {
    showActivationError() {
      this.showActivationPopup = true
    },
    showLinkedInConnectPrompt() {
      this.showLinkedInConnect = true
    },
    updatePhoneAndEmailFromSmtp(res) {
      this.smptCompleted = true
      this.updateEmail(res, this.profileData)
    },
    updatePhoneForId(result) {
      this.updatePhone(result, this.profileData)
    },
    findEmail(autoTrigger, showNotification = true) {
      if (this.profileData && this.profileData.domain) {
        this.findEmailLoading = true
        const reqData = this.constructReqData(this.profileData)
        post('li/adv/profile.htm', reqData, this.requestId)
          .then((response) => {
            if (response.status == 200) {
              response.json().then((res) => {
                if (res) {
                  const errorMsg = this.findEmailCallback(
                    res,
                    autoTrigger,
                    this.profileData
                  )
                  this.errorMsg = errorMsg
                  if (showNotification)
                    sharedFunctions.showNotificationMsg(this.errorMsg.msg)
                  this.findEmailLoading = true
                }
              })
            }
          })
          .catch((e) => {
            this.findEmailLoading = true
            console.log('error: ' + e)
          })
      }
    },
    findEmailWithCustomDomain(inputData, uniqueId) {
      if (this.profileData && uniqueId === this.profileData.uniqueId) {
        const id = this.profileData.linkedinId
        this.profileData.isVerifiedDomain = false
        this.profileData.isActivelyWorking = true
        this.profileData.domain = inputData.domain
        this.$store.state.linkedin.bulk.contacts[id].domain = inputData.domain
        this.$store.state.linkedin.bulk.contacts[id].companyName =
          inputData.companyName
        this.findEmail(true)
      }
    },
    constructReqData(profile) {
      let reqData = {}
      //reqData['linkedinId'] = profile['linkedinId']
      reqData['fullName'] = profile['fullName']
      reqData['address'] = profile['address']
      reqData['companyName'] = profile['companyName']
      reqData['domain'] = profile['domain']
      reqData['title'] = profile['title']
      reqData['verifiedDomain'] = profile['isVerifiedDomain']
      reqData['companyUrl'] = profile['companyUrl']
      reqData.salesNavigator = profile.isSalesNavigator || false
      return reqData
    },
    canShowButton() {
      return (
        this.profileData &&
        this.profileData.mcId &&
        this.profileData.email.indexOf('*') != -1
      )
    },
    copyClipboard(cId, mail, name) {
      let txtDisplay = 'Copied'
      const dataMap = {
        pageType: 'Bulk',
      }
      sharedFunctions.clickToCopy(
        cId,
        mail,
        name,
        null,
        dataMap,
        txtDisplay,
        this.$store.state
      )
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.contact-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  color: $grey-color;
  .title {
    line-height: 22px;
  }
  // .phonecard-grid {
  //   display: grid;
  //   grid-template-columns: repeat(1, 1fr);
  //   grid-row-gap: 7px;
  //   grid-column-gap: 7px;
  // }

  // .error {
  //   @extend .fn-12;
  //   @extend .p-t-10p;
  //   color: $orange;
  // }
  .no-company {
    margin-bottom: 15px;
    width: 100%;
    margin-top: 5px;
    cursor: pointer;
  }
  .no-domain {
    width: 100%;
    margin: 10px 0;
    cursor: pointer;
  }

  .top-section {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .name {
    font-size: 15px;
    line-height: 25px;
    font-family: 'Figtree-Medium';
    color: #495567;
    @extend .ellipsis;
  }
  .title {
    font-size: 14px;
    line-height: 20px;
    color: #667080;
    @extend .ellipsis;
  }
  .email-hldr {
    margin-bottom: 10px;
    color: $grey-color;

    .email-icon {
      flex-shrink: 0;
      fill: $grey-color;
    }
    .p-rel {
      overflow: hidden;
      gap: 5px;
    }
    .email {
      @extend .icon-img-spacing;
      font-size: 15px;
      line-height: 20px;
      word-break: break-word;
      &.linear-background {
        min-width: 150px;
      }
    }

    .copy-section::v-deep {
      margin-left: auto;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      transition: all 300ms ease;

      .copy-wrap {
        position: relative;
        background: #ffffff;
        border: 1px solid rgba(102, 112, 128, 0.2);
        border-radius: 6px;
        width: 34px;
        height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 300ms ease;

        &:hover svg g {
          opacity: 1;
          stroke: $primary-color;
        }
        &:hover {
          z-index: 1;
          border-color: $primary-color;
        }
        input {
          border: none;
          width: 100%;
          height: 1px;
          opacity: 0;
          box-shadow: none;
          outline: none;
          position: absolute;
          top: 10px;
          left: 5px;
          z-index: -1;
        }
      }
    }
    .copied-success {
      color: #484848;
      display: none;
      font-size: 11px;
      position: absolute;
      top: 20px;
      width: 40px;
      left: 5px;
    }
    .show {
      display: block;
    }
  }
  .c-grey {
    color: $grey-color;
  }
  .left-section {
    @extend .ellipsis;
    margin: 7px 10px 0 0;
    flex-shrink: 0;
    display: flex;
    &.placeholder {
      gap: 5px;
      flex-direction: column;
    }
  }
  .right-section {
    flex-grow: 1;
    overflow: hidden;
  }
  .line-1-25 {
    line-height: 1.25;
  }

  .but-holder {
    margin-left: auto;
    align-items: start;
    justify-content: flex-end;
    .linear-background {
      width: 50px;
    }
  }
}
</style>
